/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { merge } from 'lodash';

const useStyles = customStyle =>
  makeStyles((theme) => {
    const styles = {
      sectionInfo: {
        backgroundColor: 'transparent',
        borderRadius: '0.2rem',
        padding: '1rem 0.2rem',
      },
      sectionInfoDisplay: {
        display: 'flex',
      },
      infoIcon: {
        color: theme.palette.info.main,
        marginRight: '0.5rem',
      },
      infoText: {
        marginBottom: 0,
        color: theme.palette.mainText,
      },
    };

    merge(styles, customStyle);

    return styles;
  });

/**
 * Section info field with customizable styling.
 * Setting custom style properties can be done from the uiSchema by adding a 'customStyle' object
 * with all all the customized properties inside the ui:options.
 *
 * E.g.:
 *     "sectionInformation": {
 *     "ui:field": "InformationField",
 *     "ui:options": {
 *       "customStyle": {
 *         "sectionInfo": {
 *           "backgroundColor": "yellow"
 *         },
 *       },
 *       "style": {
 *         "width": "60rem"
 *       }
 *     }
 *   }
 */
export default function InformationField(props) {
  const { uiSchema, schema } = props;
  const classes = useStyles(uiSchema?.['ui:options']?.customStyle)();
  const hidden = uiSchema?.['ui:hidden'];

  return hidden ? null : (
    <Grid container direction="row" alignItems="center" className={classes.sectionInfo}>
      <div className={classes.sectionInfoDisplay}>
        <Info className={classes.infoIcon} />
        <Typography className={classes.infoText} variant="body1" data-testid="info-text">
          <span dangerouslySetInnerHTML={{ __html: schema?.text }} />
        </Typography>
      </div>
    </Grid>
  );
}
